module.exports = __webpack_public_path__ + "static/img/jigou-heilongjiang-top.a237ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-heilongjiang-top.png
// module id = S3QK
// module chunks = 2